import styled from 'styled-components';
import { Box, BoxProps } from '../Box/Box';

interface ColumnProps extends BoxProps {
  width?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  offset?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  textAlign?: 'left' | 'center' | 'right';
  theme?: any;
  truncate?: boolean;
}

export const Column = styled(Box)<ColumnProps>`
  ${({ width = 1, offset = 0, textAlign = 'left', truncate }) => `
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0 8px;
    margin-left: ${(offset / 12) * 100}%;
    text-align: ${textAlign};
    width: ${(width / 12) * 100}%;
    box-sizing: border-box;
    white-space: ${truncate && 'nowrap'};
    text-overflow: ${truncate && 'ellipsis'};
    overflow: ${truncate && 'hidden'};
  `}

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;
